// src/components/exam-player/renderers/TrueFalseRenderer.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export default function TrueFalseRenderer({
  item,
  onAnswerChange,
  initialAnswers,
  questionNumber,
}) {
  const { t } = useTranslation();

  const layout = item?.body?.layout || "top-bottom";
  const isVertical = layout === "top-bottom" || layout === "bottom-top";

  const ordered = useMemo(() => {
    const base = [
      { key: "true", label: t("truefalse.true", "True") },
      { key: "false", label: t("truefalse.false", "False") },
    ];
    return layout === "bottom-top" || layout === "left-right"
      ? [...base].reverse()
      : base;
  }, [layout, t]);

  // --- state داخلی انتخاب ---
  const [value, setValue] = useState(
    typeof initialAnswers === "string"
      ? initialAnswers
      : initialAnswers?.value ?? undefined
  );

  // همگام‌سازی وقتی prop عوض شد (مثلاً با برگشت به صفحه)
  useEffect(() => {
    const next =
      typeof initialAnswers === "string"
        ? initialAnswers
        : initialAnswers?.value ?? undefined;
    setValue(next);
  }, [initialAnswers]);

  // نام یکتا برای گروه رادیو
  const name = useMemo(() => {
    if (typeof questionNumber === "number") return `tf-q-${questionNumber}`;
    return `tf-${Math.random().toString(36).slice(2)}`;
  }, [questionNumber]);

  const handleChange = (e) => {
    const v = e.target.value === "true" ? "true" : "false";
    setValue(v);
    onAnswerChange?.(v); // ← به والد خبر بده (رشته‌ی "true"/"false")
  };

  return (
    <div className="flex items-start gap-3">
      {typeof questionNumber === "number" && (
        <div
          aria-hidden
          className="mt-1 inline-flex h-6 min-w-6 items-center justify-center rounded-full border text-xs font-medium px-2"
        >
          {questionNumber}
        </div>
      )}

      <div
        className={
          isVertical
            ? "flex flex-col gap-2"
            : "flex flex-row flex-wrap items-center gap-4"
        }
      >
        {ordered.map((opt) => (
          <label
            key={opt.key}
            className="inline-flex items-center gap-2 cursor-pointer select-none"
          >
            <input
              type="radio"
              name={name}
              value={opt.key}
              checked={value === opt.key}
              onChange={handleChange}
              className="h-4 w-4 text-purple-600 focus:ring-purple-500"
            />
            <span className="text-sm">{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
